export default __webpack_public_path__ + "static/media/bitcoin dude.e869674c.png";